import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase';
import { signOut, onAuthStateChanged, sendPasswordResetEmail } from 'firebase/auth';
import axios from 'axios';
import { useFichario } from '../context/ficharioContext';
import { axiosWithAuth } from '../services/api.js';
import { useLoading } from '../context/loadingContext.js';
import { useAuth } from '../context/AuthContext.js';

import { getStorage, ref, getBlob } from "firebase/storage";
import { saveAs } from "file-saver";
import { useAlert } from '../context/alertContext';


const UserArea = () => {
  const navigate = useNavigate();
  const [userName, setUserName] = useState('');
  const [uid, setUid] = useState(null);
  const [userData, setUserData] = useState(null);
  const { loading, setLoading } = useLoading();
  const [error, setError] = useState('');

  const { fichario, setFichario, fetchFichario, needCaptcha } = useFichario();


  const storage = getStorage();

  const { showAlert } = useAlert();

  const { currentUser } = useAuth();


  async function baixarArquivo(path, nomeArquivo = "arquivo.pdf") {
    try {
      const fileRef = ref(storage, path);
      console.log("fileRef", fileRef);
      const blob = await getBlob(fileRef);
      saveAs(blob, nomeArquivo);
    } catch (err) {
      console.log("Erro ao baixar o arquivo:", err);
      let mensagem = "Ocorreu um erro ao baixar o arquivo.";
      if (err.code === "storage/object-not-found") {
        mensagem = "Arquivo não encontrado no servidor.";
      } else if (err.code === "storage/unauthorized") {
        mensagem = "Você não tem permissão para acessar este arquivo.";
      } else if (err.code === "storage/canceled") {
        mensagem = "Download cancelado.";
      }

      showAlert(mensagem, "tempo", "erro");
    }
  }



  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUid(user.uid);
        //console.log("UID do usuário autenticado:", user.uid, fichario);
      } else {
        setUserName('');
        setUid(null);
      }
    });

    return () => unsubscribe();
  }, []);





  useEffect(() => {
    if (uid && !needCaptcha) {
      fetchFichario();
    }
  }, []);




  // const pollingStarted = useRef(false);

  // useEffect(() => {
  //   if (!uid || needCaptcha || !fichario?.compra) return;

  //   const { status, respostaEnviada } = fichario.compra;

  //   // Ref para garantir que só inicia uma vez


  //   if (status === 'approved' && !respostaEnviada && !pollingStarted.current) {
  //     pollingStarted.current = true;

  //     console.log("Polling chamado");
  //     const interval = setInterval(() => {
  //       fetchFichario();
  //     }, 15000);

  //     return () => {
  //       clearInterval(interval);
  //       pollingStarted.current = false;
  //     };
  //   }
  // }, [uid, needCaptcha, fichario]);


  const handleLogout = async () => {
    try {
      const user = auth.currentUser;
      const uid = user.uid;

      const axiosInstance = await axiosWithAuth();
      await axiosInstance.post('/revoke-token', { uid });

      await signOut(auth);
      setFichario(null);
      localStorage.clear();
      navigate('/');
    } catch (err) {
      console.error('Erro ao deslogar com revogação:', err);
      try {

        await axios.post('${baseURL}/logs', {
          level: 'error',
          message: `Erro ao deslogar usuário.`,
          context: 'userArea',
          userId: null,
          stack: 'handleLogout'
        });
      } catch (logErr) {
        console.warn('Falha ao enviar log para /logs:', logErr.message);
      }
    }
  };



  const handleRecuperarSenha = () => {
    if (!currentUser.email) {
      showAlert("Digite o e-mail para recuperar a senha.", "tempo", "erro");
      return;
    }

    sendPasswordResetEmail(auth, currentUser.email)
      .then(() => {
        showAlert("E-mail de recuperação enviado!", "tempo", "ok");
      })
      .catch(error => {
        console.error("Erro ao enviar e-mail de recuperação:", error);
        showAlert("Erro ao enviar e-mail de recuperação. Verifique o e-mail digitado.", "tempo", "erro");
      });
  };






  if (!fichario) return <p>Carregando dados do usuário...</p>;

  const { user, compra } = fichario;


  return (

    <div className="admin-page">
      <h3 className='top-margin'>
        BEM-VINDO, <br></br>{user?.nomeCompleto?.toUpperCase() || 'USUÁRIO'}!
      </h3>

      <p className='top-margin'>E-mail: <strong>{currentUser.email}</strong></p>
      <a type="button" className="recuperar-senh dark-green-underline" onClick={handleRecuperarSenha}>
        Alterar minha senha
      </a>


      {loading ? (
        <p>Carregando dados...</p>
      ) : error ? (
        <p className="error-message">{error}</p>
      ) : (
        <div className="medium-top-margin">
          {!compra ? (
            <p>Ainda não identificamos nenhum pedido de revisão em seu nome.</p>
          ) : (
            <div className="medium-top-margin center">
              <h3 className='underline'>Resultados:</h3>
              {compra.status !== "approved" ? (
                <p>Seu pagamento ainda não foi confirmado.</p>
              ) : compra.respostaEnviada ? (
                <ul>
                  {compra.resultadoUrl && (
                    <li>
                      <a aria-label="Baixar requerimento em PDF" onClick={() => baixarArquivo(compra.resultadoUrl, "Requerimento.pdf")}>
                        <i className="fas fa-file-pdf" aria-hidden="true"></i> Requerimento
                      </a>
                    </li>
                  )}
                  <li>
                    <a aria-label="Baixar relatório em PDF" onClick={() => baixarArquivo(compra.relatorioUrl, "Relatorio.pdf")}>
                      <i className="fas fa-file-pdf" aria-hidden="true"></i> Relatório
                    </a>
                  </li>
                </ul>
              ) : (
                <p>Seu resultado está sendo auditado.<br />Por favor, tente mais tarde.</p>
              )}


              {compra.status === "approved" && (
                <div className="medium-top-margin center">
                  <h3 className='underline'>Nota Fiscal:</h3>
                  {compra.respostaEnviada && compra.nota_pdf ? (
                    <ul>
                      <li>
                        <a aria-label="Baixar nota fiscal em PDF" onClick={() => baixarArquivo(compra.nota_pdf, "Nota.pdf")}>
                          <i className="fas fa-file-pdf" aria-hidden="true"></i> Nota Fiscal
                        </a>
                      </li>
                    </ul>
                  ) : (
                    <p>Sua nota fiscal está sendo emitida.<br />Por favor, tente mais tarde.</p>
                  )}
                </div>
              )}

              <div className='medium-top-margin'>
                <p style={{ fontSize: '16px' }}><span style={{ color: 'red' }}>ATENÇÃO: </span>Por política de armazenamento,<br></br>os resultados expiram 63 dias após a compra.<br></br>Salve no seu dispositivo.</p>
              </div>

            </div>
          )}
        </div>
      )}

      <div>
        <button className="medium-top-margin" onClick={handleLogout}>Sair</button>
      </div>
    </div>

  );




};

export default UserArea;
